import { useEffect } from "react"
import { useSelector } from "react-redux"

import type { Configuration } from "@/types/api-types"
import type { RootState } from "@/types/redux"
import { useFetch } from "./use_fetch"
import { useReduxState } from "./use_redux_state"

const useConfiguration = (): [Configuration | null, boolean, unknown] => {
  const hasAuth = useSelector((state: RootState) => Boolean(state.auth?.user))
  const path = `/${hasAuth ? "protected" : "public"}/configuration`
  const [configuration, isLoading, error] = useFetch<Configuration>(path, { useCache: !hasAuth })
  const [, setConfiguration] = useReduxState({ key: "configuration" })

  useEffect(() => {
    setConfiguration(configuration)
  }, [configuration, setConfiguration])

  return [configuration, isLoading, error]
}

export default useConfiguration
